import { Component } from '@angular/core';

/**
 * Generated class for the TaskDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'task-details',
  templateUrl: 'task-details.html'
})
export class TaskDetailsComponent {

  text: string;

  constructor() {
    //console.log('Hello TaskDetailsComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/task-details/task-details.ts